/**
 * resolveArFormulaOwnedTypeIds
 *
 * The single definition of the typeIds the formula engine writes: every target
 * in the sequence, plus the root column of every dotted target — a dotted write
 * to `cells.<root>.value.fields.<sub>.value` can replace the root's scalar
 * `value` with a map, so the plain `<root>` operand is engine-owned too.
 * Consumed by evaluateRowFormulas (owned variables never read the raw cell)
 * and resolveArFormulaInputs (owned typeIds never enter the fingerprint). The
 * two MUST share this set: if they diverge, the engine reads its own output
 * and the reconcile trigger self-retriggers forever (SYD-2292).
 */

import type { ArFormulaEntry } from '../System.Artifacts.types';

function resolveArFormulaOwnedTypeIds(formulaSequence: ArFormulaEntry[]): Set<string> {
  const owned = new Set<string>();
  for (const { typeId } of formulaSequence) {
    const target = typeId as string;
    owned.add(target);
    const dotIndex = target.indexOf('.');
    if (dotIndex !== -1) {
      owned.add(target.slice(0, dotIndex));
    }
  }
  return owned;
}

export { resolveArFormulaOwnedTypeIds };
